import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

const FirstNameComponent = ({ value, isErrored, onChange, placeholder = '' }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-first-name">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-first-name">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="firstName"
                        defaultMessage="First name"
                    />
                </div>
            </label>
            <input
                className={
                    `sid-text-input sid-text-input--required
                        sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                }
                id="sid-first-name"
                name="sid-first-name"
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                ref={input => setRef('firstName', input)}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidFirstName"
                            defaultMessage="Invalid first name"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  FirstNameComponent };
